import axios from 'axios';

import {
    CompanyFguiPort,
    FguiApplication,
    FguiConnection,
    FguiPortProfile,
    ListResult,
    SaveUserFguiPortSettingRequest,
    UserFguiPortSetting
} from '../schemas/fguiPort.schema';

const headers = () => ({ Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH') });

// Users
export const getActiveProfiles = () =>
    axios.get<ListResult<FguiPortProfile>>('/v1/fgui-port/profiles', { headers: headers() });

export const getUserSetting = () =>
    axios.get<UserFguiPortSetting>('/v1/fgui-port/setting', { headers: headers() });

export const saveUserSetting = (body: SaveUserFguiPortSettingRequest) =>
    axios.put('/v1/fgui-port/setting', body, { headers: headers() });

export const getConnection = (sid: string) =>
    axios.get<FguiConnection>('/v1/fgui-port/connection', { params: { sid }, headers: headers() });

// Super Admin
export const getAllProfiles = () =>
    axios.get<ListResult<FguiPortProfile>>('/v1/fgui-port/admin/profiles', { headers: headers() });

export const saveProfile = (body: FguiPortProfile) =>
    axios.post('/v1/fgui-port/admin/profiles', body, { headers: headers() });

export const getCompanyPorts = (sid: string) =>
    axios.get<ListResult<CompanyFguiPort>>('/v1/fgui-port/admin/company-ports', {
        params: { sid },
        headers: headers()
    });

export const getCompanyGuiApplications = (sid: string) =>
    axios.get<ListResult<FguiApplication>>('/v1/fgui-port/admin/gui-applications', {
        params: { sid },
        headers: headers()
    });

export const saveCompanyPort = (body: CompanyFguiPort) =>
    axios.post('/v1/fgui-port/admin/company-ports', body, { headers: headers() });

export const deleteCompanyPort = (sid: string, profileId: string) =>
    axios.delete('/v1/fgui-port/admin/company-ports', {
        params: { sid, profile_id: profileId },
        headers: headers()
    });
